module.exports = __webpack_public_path__ + "img/banner.f9d27e26.jpg";